import PublicTrainerProfilePage from './PublicTrainerProfilePage';

export default PublicTrainerProfilePage;
